var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const DIRECTION_TRANSFORM = {
    down: undefined,
    right: 'rotate(270 16 16)',
    up: 'rotate(180 16 16)',
    left: 'rotate(90 16 16)',
};
const Chevron = (_a) => {
    var { direction } = _a, props = __rest(_a, ["direction"]);
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    const transform = DIRECTION_TRANSFORM[direction];
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("g", { transform: transform, children: _jsx("path", { d: "M28 10L16.0001 22L4 10", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round" }) }) })));
};
export default Chevron;
